const musicLinkUrlPartsFR = {
    "view": {
        "table": {
            "title": "Votre liste de parties d'URL de liens musicaux",
            "column": {
                "part": "Partie",
                "owner": "Propriétaire",
                "action": "Action"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "button": {
                "exportCSV": "Exporter CSV"
            }
        },
        "message": {
            "success": "La partie d'URL du lien musical a été supprimée !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "noUrlparts": "Actuellement, cette fonctionnalité n'est offerte qu'à quelques utilisateurs sélectionnés, mais la bonne nouvelle est que vous pourrez également l'utiliser très bientôt. Continuez à surveiller cet espace !"
        },
        "modal": {
            "delete": {
                "header": "Supprimer {{mlUrlpart}} ?",
                "body": "Êtes-vous sûr de vouloir supprimer cette partie d'URL de lien musical ?"
            },
            "canNotDelete": {
                "header": "Impossible de supprimer la partie d'URL de lien musical {{mlUrlPart}}",
                "body": "La partie d'URL de lien musical {{mlUrlPart}} ne peut pas être supprimée car elle est déjà associée à un lien musical."
            }
        }
    },
    "add": {
        "form": {
            "label": {
                "subUser": "Sous-utilisateur",
                "part": "Partie",
                "owner": "Propriétaire",
                "addUrlPart": "Ajouter une partie d'URL",
                "editUrlPart": "Modifier la partie d'URL"
            },
            "placeholder": {
                "subUser": "Sélectionner un sous-utilisateur..."
            },
            "help_text": {
                "subUser": "Remarque : Utilisez ce menu déroulant uniquement si vous souhaitez ajouter un lien musical pour l'un de vos sous-utilisateurs, sinon laissez non sélectionné."
            },
            "button": {
                "reset": "Réinitialiser",
                "submit": "Soumettre"
            },
            "validation": {
                "part": {
                    "required": "La partie est requise",
                    "max": "Doit comporter exactement 16 caractères"
                }
            },
            "message": {
                "subUserLimit": "Ce sous-utilisateur a atteint la limite maximale de 10 parties d'URL.",
                "urlPartAlreadyTaken": "Cette URL de lien musical est déjà prise par votre compte ou un autre compte utilisateur. Veuillez essayer autre chose."
            }
        },
        "message": {
            "addSuccess": "La partie d'URL du lien musical a été ajoutée !",
            "updateSuccess": "La partie d'URL du lien musical a été mise à jour !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        }
    }
};

export default musicLinkUrlPartsFR;